<template>
  <div class="user-container container h-100">
    <div class="header">
      <el-form class="form" label-width="100px" size="mini" inline>
        <el-form-item label="邮箱" label-width="50px">
          <el-input v-model="query.email" placeholder="请输入邮箱" @change="onSubmit" clearable></el-input>
        </el-form-item>
        <el-form-item label="账号" label-width="60px">
          <el-input v-model="query.username" placeholder="请输入账号" @change="onSubmit" clearable></el-input>
        </el-form-item>
        <el-form-item label="昵称" label-width="60px">
          <el-input v-model="query.name" placeholder="请输入昵称" @change="onSubmit" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态" label-width="60px">
          <el-select v-model="query.status" clearable @change="onSubmit">
            <el-option :value="1" label="启用">启用</el-option>
            <el-option :value="0" label="停用">停用</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" label-width="50px">
          <el-select v-model="query.role_id" placeholder="选择角色" filterable clearable
                     @change="onSubmit" @focus="loadRoleList">
            <el-option
                v-for="(val, key) in roles"
                :key="key + 'role'"
                :label="val.role_name" :value="val.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="el-button--operation" size="mini"
                     style="margin-left:20px;" @click="onSubmit">查询
          </el-button>
          <el-button @click="onReset" style="margin-right:0;" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row :gutter="15" style="margin-bottom: 8px">
      <el-col :span="1.5">
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="addUser">新增用户</el-button>
      </el-col>

      <!--      <el-col :span="1.5">-->
      <!--        <el-button type="default" size="mini" icon="el-icon-user" @click="openUserOnline=true">在线用户</el-button>-->
      <!--      </el-col>-->
      <el-col :span="1.5">
        <el-button type="primary" plain size="mini" @click="showUserPurview">用户权限</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-popover
            placement="bottom"
            width="550"
            trigger="click">
          <div class="default-table">
            <el-table :data="userDeletedData" id="tmp-order-table" style="width: 100%">
              <el-table-column min-width="130" property="username" :show-overflow-tooltip="true"
                               label="账号"/>
              <el-table-column min-width="130" property="email" :show-overflow-tooltip="true" label="邮箱"/>
              <el-table-column min-width="130" property="name" :show-overflow-tooltip="true"
                               label="昵称"/>
              <el-table-column width="80" label="操作">
                <template slot-scope="scope">
                  <el-button
                      style="padding: 0 0"
                      type="text"
                      size="mini"
                      icon="el-icon-refresh-left"
                      @click="undoDelete(scope.row.id,scope.row.username)"
                  >撤回
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <Pagination
                v-show="deleteListParams.total>0"
                layout="prev, pager, next"
                :total="deleteListParams.total"
                :page.sync="deleteListParams.page"
                :limit.sync="deleteListParams.per_page"
                @pagination="getUserDeletedList"
            />
          </div>
          <el-button
              size="mini"
              style="margin-right:20px;"
              slot="reference"
              @click="getUserDeletedList"
          >
            回收站
          </el-button>
        </el-popover>
      </el-col>
    </el-row>

    <!--    用户列表-->
    <el-row class="panel-container">
      <el-col :span="24">
        <div class="default-table mlTable-table" ref="tblDiv"  v-loading='loading'
             element-loading-text='加载中……'
             element-loading-spinner='el-icon-loading'>
          <el-table :data="userData" @sort-change="sortChange" border>
            <el-table-column label="序号" type="index" align="center" width="55">
              <template slot-scope="{$index}">
                {{ offset + $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="头像" align="center" width="80">
              <template slot-scope="scope">
                <el-avatar :src="scope.row.avatar" :size="40" shape="square">
                  <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"/>
                </el-avatar>
              </template>
            </el-table-column>
            <el-table-column label="账号" prop="username" align="center" sortable="custom"
                             width="100"></el-table-column>
            <el-table-column label="昵称" prop="name" align="center" sortable="custom" width="100"></el-table-column>
            <el-table-column label="邮箱" prop="email" align="center" sortable="custom" width="120"></el-table-column>
            <el-table-column label="性别" prop="sex" width="90" align="center" sortable="custom"></el-table-column>
            <el-table-column label="钉钉绑定" prop="is_bind_dd" width="100" align="center" sortable="custom">
              <template slot-scope="{row}">
                <span :class="[row.is_bind_dd===1?'success-cell':'warning-cell']">{{
                    row.is_bind_dd == 1 ? '已绑定' : '未绑定'
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column label="角色" prop="role_name" align="center" min-width="160"></el-table-column>
            <el-table-column label="小组" prop="organization_name" align="center" min-width="100"></el-table-column>
            <el-table-column label="组内职位" prop="organization_position" align="center"
                             min-width="100"></el-table-column>
            <el-table-column label="状态" prop="status" align="center" width="80" sortable="custom">
              <template slot-scope="{row}">
                <span :style="{color:statusFilterColor(row.status)}">{{ statusFilterText(row.status) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="上次登录时间" prop="login_at" align="center" sortable="custom"
                             width="140"></el-table-column>
            <el-table-column label="上次登录IP" prop="login_ip" align="center" width="120"></el-table-column>
            <el-table-column label="创建时间" prop="created_at" align="center" sortable="custom"
                             width="130"></el-table-column>
            <el-table-column label="修改时间" prop="updated_at" align="center" sortable="custom"
                             width="130"></el-table-column>
            <el-table-column
                label="操作项"
                align="center"
                width="230"
                fixed="right"
            >
              <template slot-scope="scope">
                <div>
                  <el-button type="text" size="mini" @click="handleResetPwd(scope.row)" icon="el-icon-key">重置</el-button>
                  <el-button type="text" size="mini" @click="editUser(scope.row)" icon="el-icon-edit">修改</el-button>
                  <el-button type="text" size="mini" @click="deleteRow(scope.row)" icon="el-icon-delete">删除</el-button>
                  <el-button type="text" size="mini" @click="userLogView(scope.row)" icon="el-icon-view">日志</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="mlTable-page">
            <div class="mlTable-do">
              <el-tooltip class="item" effect="dark" content="刷新表格" placement="top">
                <el-button @click="handleQuery" icon="el-icon-refresh" circle
                           style="margin-left:1px;margin-top: 10px"></el-button>
              </el-tooltip>
            </div>

            <div class="mlTable-pagination">
              <Pagination
                  v-show="pageData.total>0"
                  :total="pageData.total"
                  :page.sync="pageData.page"
                  :limit.sync="pageData.per_page"
                  @pagination="handleQuery"
              />
            </div>


          </div>

        </div>
      </el-col>
    </el-row>

    <el-dialog :title="type==='store'?'新增用户':'编辑用户'" :visible.sync="dialogTableVisible"
               width="clamp(800px,75vw,1200px)">
      <el-form :model="userForm" class="userForm" ref="userForm" :rules="rules" label-width="100px" size="mini"
               auto-complete="off"
               style="text-align:left;padding:0 10px;">
        <el-row>
          <el-col :span="12">
            <el-form-item label="账号" prop="username">
              <el-input v-model="userForm.username" placeholder="请输入账号" autocomplete="off"
                        auto-complete="new-username" maxlength="50" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="昵称">
              <el-input v-model="userForm.name" placeholder="请输入昵称（默认姓名）" autocomplete="off"
                        auto-complete="new-name" maxlength="50"
                        show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="type === 'store'">
            <el-form-item label="密码" prop="password">
              <el-input v-model="userForm.password" placeholder="请输入密码" autocomplete="off"
                        auto-complete="new-password" show-password maxlength="30"
                        show-word-limit>
                <el-button slot="append" @click="makePassword" title="推荐规则：长度12位，包含大小写字母和数字">生成密码
                </el-button>
              </el-input>

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="userForm.email" placeholder="请输入邮箱" autocomplete="off" maxlength="100"
                        show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="性别">
              <el-radio-group v-model="userForm.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="0">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-switch
                  v-model="userForm.status"
                  active-color="#3296FF"
                  inactive-color="#CACACA"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="开"
                  inactive-text="关">
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="小组" prop="organization_id">
              <el-select v-model="userForm.organization_id" placeholder="请选择小组" clearable>
                <el-option v-for="item in teamOptions" :key="item.id" :value="item.id"
                           :label="item.label"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职位">
              <el-radio-group v-model="userForm.bool_leader">
                <el-radio :label='1'>组长</el-radio>
                <el-radio :label='0'>组员</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <!--                <el-row>-->
        <!--                    <el-form-item label="超级管理员">-->
        <!--                        <el-radio-group v-model="userForm.bool_admin">-->
        <!--                            <el-radio :label='1'>是</el-radio>-->
        <!--                            <el-radio :label='0'>否</el-radio>-->
        <!--                        </el-radio-group>-->
        <!--                    </el-form-item>-->
        <!--                </el-row>-->
        <el-row style="max-height: 300px;overflow:auto;">
          <el-col :span="24">
            <el-form-item label="角色" prop="role">
              <el-checkbox-group v-model="userForm.role" size="mini" @change="changeCheck">
                <el-checkbox v-for="(role,index) in roles" :key='index' :label="role.name" border
                             style="width: 150px;">
                  {{ role.role_name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>

        <div style="text-align:center;">
          <el-button type="primary" @click="confirmAdd('userForm')" style="margin-right:50px;width: 100px">
            {{ type === 'store' ? '确认添加' : '保存修改' }}
          </el-button>
          <el-button type="info" @click="cancel" style="width: 100px">取消</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!--    在线用户-->
    <user-online :visible.sync="openUserOnline"/>

    <!--    用户权限-->
    <user-purview ref="refUserPurview"/>

    <!--    用户更新日志-->
    <el-dialog title="查看日志" :visible.sync="dialogUserLog.is_show"
               width="clamp(800px,75vw,1200px)"
               @close="handleUserLogDialogClose">
      <div style="background-color: #FFFFFF">
        <el-table :data="dialogUserLog.list" border>
          <el-table-column label="序号" type="index" align="center" width="55" />
          <el-table-column label="操作人" prop="op_nm" align="center" width="120" />
          <el-table-column label="操作类型" prop="op_type_nm" align="center" width="100" />
          <el-table-column label="修改内容" prop="memo" align="left" show-overflow-tooltip />
          <el-table-column label="创建时间" prop="created_at" align="center" width="130" />
        </el-table>
        <div class="mlTable-page">
          <div class="mlTable-do">
            <el-tooltip class="item" effect="dark" content="刷新表格" placement="top">
              <el-button @click="handleQueryUserLogList" icon="el-icon-refresh" circle
                         style="margin-left:1px;margin-top: 10px"></el-button>
            </el-tooltip>
          </div>

          <div class="mlTable-pagination">
            <Pagination
                v-show="dialogUserLog.page.total>0"
                :total="dialogUserLog.page.total"
                :page.sync="dialogUserLog.page.page"
                :limit.sync="dialogUserLog.page.per_page"
                @pagination="handleQueryUserLogList"
            />
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserList,
  getUserDetail,
  getRoleList,
  addOrEditUser,
  deleteUser,
  getDeletedList,
  undoDelete, updatePassword
} from '@/api/user'
import { getUserLogList } from '@/api/userLog'
import {getAuth} from '@/api/login'
import {options} from '@/api/organization'
import UserOnline from "./userOnline";
import UserPurview from "@/views/sysSetting/UserPurview";
import {copyToClipboard, generatePassword} from "@/utils/security";

const statusMap = {
  '0': {
    text: '停用',
    color: '#FE5B83'
  },
  '1': {
    text: '启用',
    color: '#39BA85'
  },
  '2': {
    text: '停用 ',
    color: '#FE5B83'
  }
}
export default {
  name: 'user',
  components: {
    UserPurview,
    UserOnline
    // commonTable
  },
  data() {
    return {
      dialogTableVisible: false,
      loading: false,
      openUserOnline: false,//在线用户弹出框
      statusMap,
      email: '',//查询条件邮箱
      query: {
        email: '',//查询条件邮箱
        username: '',//账号
        name: '',//昵称
        role_id: '',
        status: null,//启用状态
        orderBy: "`id` desc"
      },
      pageData: {
        page: 1,
        per_page: 15,
        total: 0,
      },
      deleteListParams: {
        page: 1,
        total: 100,
      },
      theadData: [],
      userData: [],
      userDeletedData: [], // 已经被删除的用户

      type: '', //操作 添加store,编辑update
      id: '', //current operate id
      bool_leader: 0,
      userForm: {
        name: '', //昵称
        username: '',	//账号
        password: '',
        email: '',
        status: 1, //状态，2:已停用 1:启用，0:未激活
        sex: 1,//性别:0-女 1-男
        bool_admin: 0,//是否超级管理员，1:是，0:否
        organization_id: '',// 小组ID
        bool_leader: '',//是否组长，1:是，0:否
        role: []
      },
      teamOptions: [], // 小组下拉
      roles: [],
      rules: {
        username: [
          {required: true, message: '请输入账号', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ],
        email: [
          {required: true, message: '请输入邮箱地址', trigger: 'blur'},
          {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
        ],
        role: [
          {required: true, message: '请选择角色', trigger: 'blur,change'}
        ]
      },
      topHeight: 0,
      dialogUserLog: {
        is_show: false,
        loading: false,
        query: { info_id: null },
        list: [],
        page: { page: 1, per_page: 15, total: 0 },
      }
    }
  },
  computed: {
    height() {
      // return 800
      return window.screen.height - this.topHeight - 50 - 64
      // return '100%'
    },
    offset() {
      return (this.pageData.page - 1) * this.pageData.per_page
    }
  },
  created() {
    this.loadRoleList();
    this.getTeamList();
    // this.getUserDeletedList();
    // this.getUserList(this.pageData)
    this.onSubmit()
  },
  methods: {
    /** 重置密码按钮操作 */
    handleResetPwd(row) {
      this.$msgbox.prompt('请输入"' + row.username + '"的新密码', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(({value}) => {
        if (!value || value == '') {
          this.$notify.warning('密码不能为空');
          return
        }
        let _this = this
        updatePassword({id: row.id, password: value}).then(res => {
          if (res.success) {
            this.showToast({
              h: _this
            })
          } else {
            this.$notify.warning(`密码重置失败:${res.message}`);
          }

        })
      }).catch(() => {
      });
    },
    onSubmit() {
      this.pageData.page = 1
      this.handleQuery()
    },
    handleSearchCondition() {
      let condition = {}
      const searchCondition = this.query
      Object.keys(searchCondition).forEach((field) => {
        if (searchCondition[field] != null) {
          if (Object.prototype.toString.call(searchCondition[field]) === '[object Array]') {
            if (searchCondition[field].length > 0) {
              condition[field] = this.searchCondition[field]
            }
          } else {
            // 字符串长度大于0，或数字
            if ((Object.prototype.toString.call(searchCondition[field]) === '[object String]' && searchCondition[field])
                || (Object.prototype.toString.call(searchCondition[field]) === '[object Number]')) {
              condition[field] = searchCondition[field]
            }
          }
        }
      })
      // 分页 +排序
      Object.assign(condition, this.pageData)

      return condition
    },
    handleQuery() {
      this.getUserList(this.handleSearchCondition())
    },
    onReset() {
      this.query = {
        email: '',//查询条件邮箱
        username: '',
        role_id: ''
      }
      this.onSubmit()
    },
    statusFilterText(status) {
      return statusMap[status].text
    },
    statusFilterColor(status) {
      return statusMap[status].color
    },
    loadRoleList() {
      if (this.roles && this.roles.length === 0) {
        getRoleList().then(res => {
          this.roles = res.model.role
        })
      }
    },
    //确认添加用户
    confirmAdd(formName) {
      let that = this
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let data = that.userForm
          data.type = that.type
          addOrEditUser(data).then(() => {
            that.showToast({
              h: that
            })
            that.dialogTableVisible = false
            that.handleQuery()
            getAuth().then(res => {
              let user = Object.assign({}, this.$ls.get('user'), res.model);
              let userAuth = Object.assign({}, this.$ls.get('userAuth'), res.model.permissions);
              this.$ls.set('user', user, 10800 * 1000);
              this.$ls.set('userAuth', userAuth, 10800 * 1000);
              this.$store.dispatch('update')
            })
          })
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    cancel() {
      this.dialogTableVisible = false
    },
    addUser() {
      this.type = 'store'
      this.userForm = {
        name: '', //昵称
        username: '',	//账号
        password: '',
        email: '',
        status: 1, //状态，2:已停用 1:启用，0:未激活
        sex: 1,//性别:0-女 1-男
        bool_admin: 0,//是否超级管理员，1:是，0:否
        role: [],
        organization_id: '',// 小组ID
        bool_leader: '',//是否组长，1:是，0:否
      }
      this.dialogTableVisible = true
    },
    getUserList(data) {
      this.loading = true
      getUserList(data).then(res => {
        this.userData = res.model.data || []
        this.pageData.total = res.model.total || 0
        this.loading = false
      })
    },
    sortChange({prop, order}) {
      this.query.orderBy = `\`${prop}\` ${order === 'descending' ? 'desc' : 'asc'}`
      this.handleQuery()
      // this.getUserList({...this.query, ...this.params, ...e})
    },
    resetPass(row) {
      let userForm = {
        id: row.id,
        email: row.email
      }
      const {href} = this.$router.resolve({
        name: `resetPassword`, query: {userForm: JSON.stringify(userForm)}
      });
      window.open(href, "_blank");
    },
    // 编辑用户
    editUser(row) {
      this.type = 'update'
      this.id = row.id
      this.getUserDetail(row.id)
      this.dialogTableVisible = true
      this.userForm = {
        name: '', //昵称
        username: '',	//账号
        email: '',
        status: 1, //状态，2:已停用 1:启用，0:未激活
        sex: 1,//性别:0-女 1-男
        bool_admin: 0,//是否超级管理员，1:是，0:否
        role: [],
        organization_id: '',// 小组ID
        bool_leader: 0,//是否组长，1:是，0:否
      }
    },
    getUserDetail(id) {
      getUserDetail(id).then(res => {
        this.userForm = {...this.userForm, ...res.model}
        let roles = []
        if (res.model.roles.length) {
          res.model.roles.forEach(item => {
            roles.push(item.name)
          })
        }
        if (res.model.organization) {
          this.userForm.bool_leader = res.model.organization.bool_leader
          this.userForm.organization_id = res.model.organization.organization_id
        }
        this.$set(this.userForm, 'role', roles)
      })
    },
    changeCheck() {
      // console.log(this.userForm.role);
    },
    deleteRow(row) {
      let that = this
      that.showModal({
        h: that,
        text: '确认删除该行数据吗？',
        confirm: function () {
          deleteUser(row.id).then(() => {
            that.showToast({h: that, text: '删除成功'})
            that.getUserList({...that.query, ...that.sort, ...that.params});
          })
        },
        cancel: function () {
          // console.log('cancel');
        }
      })
    },
    // 获取小组列表
    getTeamList() {
      options().then(res => {
        if (res.success) {
          this.teamOptions = res.model;
          return false
        }
        this.$message.error(res.message);
      })
    },
    getUserDeletedList() {
      getDeletedList(this.deleteListParams).then(res => {
        this.userDeletedData = res.model.data
        this.deleteListParams.total = res.model.total
      })
    },
    undoDelete(id, username) {
      const that = this
      that.showModal({
        h: that,
        text: '确认恢复 【' + username + '】 用户数据？',
        confirm: function () {
          undoDelete(id).then(() => {
            that.$message.success('操作成功');
            that.getUserDeletedList()
            that.handleQuery()
            // that.getUserList({...that.query, ...that.sort, ...that.params});
          })
        },
        cancel: function () {
          // console.log('cancel');
        }
      })

    },

    showUserPurview() {
      this.$refs['refUserPurview'].show()
    },
    // 生成密码：推荐规则-长度12位，包含大小写字母和数字
    makePassword() {
      const password = generatePassword(12, ['uppercase', 'lowercase', 'numbers'])
      this.userForm.password = password
    },
    handleCopy() {
      copyToClipboard(this.userForm.password)
      this.$message.success('已复制到剪贴板')
    },
    userLogView: function (row) {
      this.dialogUserLog.is_show = true
      this.dialogUserLog.query.info_id = row.id
      this.handleQueryUserLogList()
    },
    handleUserLogSearchCondition() {
      let condition = {}
      // 分页 +排序
      Object.assign(condition, this.dialogUserLog.query, this.dialogUserLog.page)
      // 返回
      return condition
    },
    handleQueryUserLogList() {
      this.queryUserLogList(this.handleUserLogSearchCondition())
    },
    queryUserLogList(data) {
      this.dialogUserLog.loading = true
      getUserLogList(data).then(res => {
        this.dialogUserLog.list = res.model.list || []
        this.dialogUserLog.page.total = res.model.page.total || 0
        this.dialogUserLog.loading = false
      })
    },
    handleUserLogDialogClose() {
      this.dialogUserLog.is_show = false
      this.dialogUserLog.list = []
      this.dialogUserLog.query.info_id = null
      this.dialogUserLog.page.page = 1
      this.dialogUserLog.page.total = 0
    }
  },
  mounted() {
    this.topHeight = this.$refs.tblDiv.offsetHeight
  }
}
</script>

<style lang="scss">
.user-container {

  .success-cell {
    color: #00c297;
  }

  .warning-cell {
    color: #E6A23C;
  }

  .header {
    background: #fff;
    //padding: 5px 30px 0 30px;
    margin-bottom: 5px;
  }

  .default-table tr.el-table__row .cell {
    height: 40px !important;
    line-height: 40px !important;
    font-weight: normal;
    font-size: 12px;
  }
}
</style>
